import documentFile from '@/assets/docs/sbgdocument.pdf?url';

/** The PDF, imported as a URL: the bytes are in no script and the service worker does not fetch it until it is opened. */
export const documentUrl: string = documentFile;

/** The name the visitor's computer saves the file under. */
export const DOWNLOAD_NAME = 'SBG-Company-Document.pdf';

/** The words of every place the document is offered (the top strip, the phone menu, the footer): short and plain. */
export const documentCopy = {
  label: 'Our stone catalogue',
  note: 'All our stones in one free PDF.',
  view: 'View',
  download: 'Download PDF',
  region: 'Stone catalogue',
};
